import {
  SearchIconStyled,
  StyledInput,
  UserProfileActivityCalenderTime,
  UserProfileActivityTable,
  UserProfileActivityTime,
  UserProfileEmptyDashboard,
  UserProfileFilterButton,
  UserProfileHeader,
  UserProfileMain,
  UserProfileSearch,
  UserProfileSpan,
  UserProfileSubHeader,
} from "../../pages/UserManagement/UserManagementBody/UserProfile/UserProfile.styles";
import CalenderComponent from "./CalenderComponent";
import styled from "styled-components";

const AccountTransactionTable = () => {
  return (
    <div>
      <TransactionHead>
        <UserProfileHeader>
          <UserProfileSubHeader>
            <UserProfileSpan>Transaction History</UserProfileSpan>
            <UserProfileSearch>
              <SearchIconStyled src="/assets/svg/Search.svg" />
              <StyledInput
                type="text"
                placeholder="Search history by date, amount or description"
              />
            </UserProfileSearch>
          </UserProfileSubHeader>
          <CalenderComponent />
        </UserProfileHeader>
      </TransactionHead>
    </div>
  );
};

export default AccountTransactionTable;

export const TransactionHead = styled.div`
  width: 100%;
  background: #ffffff;
  border-top: 1px solid #e8eaed;
  border-radius: 10px 10px 0px 0px;
  @media screen and (max-width: 767px) {
  }
`;
